import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useAuthStore } from '../store/authStore';

/**
 * FIX-D323-F2: how many bug reports wait for the OTE manager's triage ("להעביר ל-Claude" / "אטפל בעצמי").
 * Manager (admin) only: for everyone else nothing is requested. Uses the existing list endpoint (limit 1, meta.total).
 */
export function usePendingBugReportsCount(): number {
  const isAdmin = useAuthStore((s) => s.user?.role) === 'admin';
  const { data } = useQuery({
    queryKey: ['bug-reports', 'pending-count'],
    queryFn: () => api.getBugReportList({ triage: 'pending', limit: 1 }),
    enabled: isAdmin,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
  return isAdmin ? Number(data?.meta?.total ?? 0) : 0;
}
